import React from 'react';

function EmployeeDashboard({ user }) {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Welcome, {user?.name || 'Employee'}!</h1>
      <p>You are viewing the <strong>Employee Dashboard</strong>.</p>

      {/* Task Manager */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Task Manager</h2>
        <p>View and update your daily assigned tasks.</p>
      </section>

      {/* Schedule and Time Tracking */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Work Schedule & Time Log</h2>
        <p>Check your schedule or log hours worked.</p>
      </section>

      {/* Training & Certifications */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Training Center</h2>
        <p>Complete training modules and download certifications.</p>
      </section>

      {/* Company Resources */}
      <section style={{ marginTop: '2rem' }}>
        <h2>Company Resources</h2>
        <p>Access company policies, HR documents, and quick links.</p>
      </section>
    </div>
  );
}

export default EmployeeDashboard;
